export enum LinkCategoryEnum {
    ADMINISTRATION = 'administration',
    RESERVATIONS = 'reservations'
}

/** Path segments that never correspond to a visible sidebar node — skip them entirely, don't render a crumb */
export const ALWAYS_SKIP_SEGMENTS = ['setup'];

/** Sidebar's "CRM" Master Data category also absorbs these items from the old "General" setup column */
export const CRM_MERGED_FROM_GENERAL = ['crm-actions', 'crm-types', 'email-engagements', 'email-templates'];

/** Override auto-generated breadcrumb labels for specific path segments */
export const PATH_SEGMENT_LABELS: Record<string, string> = {
    ['reservations']: 'Reservation',
    ['manage-tour']: 'Tour Booking',
    ['travel-file-list']: 'Travel File List',
    ['self-operation-tours']: 'Escorted Tours',
    ['book-tour']: 'Book a Tour',
    ['products']: 'Operations',
    ['setup']: 'Master Data',
    ['admin']: 'Users & Roles',
    ['database']: 'System',
    ['crm']: 'CRM',
    ['crm-actions']: 'CRM Actions',
    ['crm-types']: 'CRM Types',
    ['rates-of-exchange']: 'Rates of Exchange',
    ['bsp-reconciliation']: 'BSP Reconciliation',
    // Key is the URL segment, which keeps the old wording — only the label moved.
    ['export-data-to-general-ledger']: 'Export Data',
    ['sales-revenue']: 'Sales & Revenue',
    ['sales-profit']: 'Sales & Profit',
    ['sales-profit-summary']: 'Sales & Profit Summary',
    ['rct-trc']: 'RCT/TRC',
    ['prq-rmt']: 'PRQ/RMT',
    ['inventory']: 'Travel File By Inventory',
    // startCase would render this "Left To Pay".
    ['left-to-pay']: 'Left to Pay',
    ['issue']: 'Issue Documents',
    ['find']: 'Find Documents'
} as const satisfies Record<string, string>;
